import useInputChanges from './functions/useInputChanges';
import useSubmit from './functions/useSubmit';

export default function useLogin() {
  const {
    loginType,
    login,
    cpf,
    email,
    password,
    getErrorMessageByFieldName,
    errors,
    handleLoginChange,
    handlePasswordChange,
    handleCpfChange,
    handleEmailChange,
    handleLoginTypeChange,
    setLogin,
    setPassword,
    removeError,
    setLoginType,
    setCpf,
    setEmail,
  } = useInputChanges();

  const {
    isLoading,
    handleLogin,
    isFormValid,
    context,
  } = useSubmit({
    setLogin,
    setPassword,
    removeError,
    loginType,
    cpf,
    email,
    login,
    password,
    setLoginType,
    setCpf,
    setEmail,
    errors,
  });

  return {
    isLoading,
    context,
    handleLoginTypeChange,
    loginType,
    getErrorMessageByFieldName,
    login,
    handleLoginChange,
    cpf,
    handleCpfChange,
    email,
    handleEmailChange,
    password,
    handlePasswordChange,
    handleLogin,
    isFormValid,
  };
}
